var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import "../interface/appUserId.mjs";
import "@kakaopay-common/payweb-core";
import "../constants.mjs";
import { Device } from "@kakaopay-common/user-agent";
import "../interface/openFaq.mjs";
import "../interface/openCS.mjs";
import "../interface/openNotice.mjs";
import "../interface/openPrivateAsk.mjs";
import merge from "lodash.merge";
import { setBackEvent, setDefaultBackEvent } from "../interface/ViewControl/backEvent.mjs";
import { closeWebview } from "../interface/ViewControl/closeWebview.mjs";
import "../interface/ViewControl/scrollBounces.mjs";
import { getDefaultOptions } from "./navigationOptions.mjs";
const closeEvent = () => {
  closeWebview();
};
const defaultBackEvent = () => {
  const pathName = window.location.pathname;
  window.history.back();
  setTimeout(() => {
    if (window.location.pathname === pathName) {
      closeWebview();
    }
  }, 300);
};
const defaultLeftEvent = defaultBackEvent;
const defaultRightEvent = closeEvent;
const DARK_MODE_CLASSNAME = "dark_mode";
const defaultOptions = getDefaultOptions();
class NavigationBarController {
  constructor() {
    __publicField(this, "initialized", false);
    __publicField(this, "elLeft", null);
    __publicField(this, "elLeftImage", null);
    __publicField(this, "elRight", null);
    __publicField(this, "elRightImage", null);
    __publicField(this, "elTitle", null);
    __publicField(this, "elTitleBar", null);
    __publicField(this, "elRoot", null);
    __publicField(this, "leftEventListener", null);
    __publicField(this, "rightEventListener", null);
    __publicField(this, "currentOptions", defaultOptions);
    __publicField(this, "_darkModeChangedEventListener", (e) => {
      e.matches ? document.body.classList.add(DARK_MODE_CLASSNAME) : document.body.classList.remove(DARK_MODE_CLASSNAME);
      this.setTitleBar(this.currentOptions);
    });
  }
  initialize(elRoot, options = this.currentOptions) {
    console.log("[WAVE] ================ CREATE TITLE BAR ===============");
    const elWaveArea = document.createElement("div");
    elWaveArea.setAttribute("id", "wave_area");
    elWaveArea.appendChild(this.createTitleBar());
    const elStyle = document.createElement("style");
    elStyle.appendChild(
      document.createTextNode(
        "#titleBar>button:focus{outline:none} #titleBar>button{-webkit-tap-highlight-color:transparent} #titleBar>button{padding:0;border:none;background:transparent}"
      )
    );
    document.querySelector("head").appendChild(elStyle);
    document.body.insertBefore(elWaveArea, document.body.firstChild);
    this.elTitleBar = document.querySelector("#titleBar");
    this.elTitle = document.querySelector("#title");
    this.elLeft = document.querySelector("#left");
    this.elLeftImage = document.querySelector("#leftImage");
    this.elRight = document.querySelector("#right");
    this.elRightImage = document.querySelector("#rightImage");
    this.elRoot = elRoot;
    this.currentOptions = merge(this.currentOptions, options);
    this.setTitleBar(this.currentOptions);
    if (!options.disableDarkmode) {
      this._addDarkModeListener();
    } else {
      this._removeDarkModeListener();
    }
    this.initialized = true;
  }
  setTitleBar(options) {
    this._setZIndex(options);
    this._setTitleArea(options);
    this._setLeftButton(options);
    this._setRightButton(options);
    return this.elTitleBar;
  }
  hasBeenInitialized() {
    return this.initialized;
  }
  showTitleBar() {
    this.currentOptions.visible = true;
    this.setTitleBar(this.currentOptions);
  }
  hideTitleBar() {
    this.currentOptions.visible = false;
    this.setTitleBar(this.currentOptions);
  }
  setDefaultZIndex() {
    this.currentOptions.zIndex = defaultOptions.zIndex;
    this.setTitleBar(this.currentOptions);
  }
  setZIndex(zIndex) {
    this.currentOptions.zIndex = zIndex;
    this.setTitleBar(this.currentOptions);
  }
  setTitleBarHeight(height) {
    this.currentOptions.height = height;
    this.setTitleBar(this.currentOptions);
  }
  getTitleBarHeight() {
    return this.currentOptions.height;
  }
  // public setTitleBarColor(colorCode: string) {
  //   this.currentOptions.backgroundColor = colorCode;
  //   this.setTitleBar(this.currentOptions);
  // }
  setTitleText(title) {
    this.currentOptions.title.text = title;
    this.setTitleBar(this.currentOptions);
  }
  setTitleTextAlign(align) {
    this.currentOptions.title.align = align;
    this.setTitleBar(this.currentOptions);
  }
  // public setTitleTextColor(colorCode: string) {
  //   this.currentOptions.title.color = colorCode;
  //   this.setTitleBar(this.currentOptions);
  // }
  setTitleTextSize(size) {
    this.currentOptions.title.size = size;
    this.setTitleBar(this.currentOptions);
  }
  setTitleTextBold(isBold) {
    this.currentOptions.title.bold = isBold;
    this.setTitleBar(this.currentOptions);
  }
  showLeft() {
    this.currentOptions.left.visible = true;
    this.setTitleBar(this.currentOptions);
  }
  hideLeft() {
    this.currentOptions.left.visible = false;
    this.setTitleBar(this.currentOptions);
  }
  setLeftEvent(callback) {
    this.currentOptions.left.callback = callback;
    this.setTitleBar(this.currentOptions);
  }
  setDefaultLeftEvent() {
    this.currentOptions.left.callback = defaultLeftEvent;
    this.setTitleBar(this.currentOptions);
  }
  showRight() {
    this.currentOptions.right.visible = true;
    this.setTitleBar(this.currentOptions);
  }
  hideRight() {
    this.currentOptions.right.visible = false;
    this.setTitleBar(this.currentOptions);
  }
  setRightEvent(callback) {
    this.currentOptions.right.callback = callback;
    this.setTitleBar(this.currentOptions);
  }
  setDefaultRightEvent() {
    this.currentOptions.right.callback = defaultRightEvent;
    this.setTitleBar(this.currentOptions);
  }
  setBackEvent(callback) {
    this.currentOptions.back.callback = callback;
    this.setTitleBar(this.currentOptions);
    setBackEvent(callback);
  }
  setDefaultBackEvent(isWaveMode = false) {
    if (isWaveMode) {
      setBackEvent(defaultOptions.back.callback);
    } else {
      setDefaultBackEvent();
    }
    this.currentOptions.back.callback = defaultOptions.back.callback;
    this.setTitleBar(this.currentOptions);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setBackClose() {
  }
  showBottomBorder() {
    this.currentOptions.bottomBorder.visible = true;
    this.setTitleBar(this.currentOptions);
  }
  hideBottomBorder() {
    this.currentOptions.bottomBorder.visible = false;
    this.setTitleBar(this.currentOptions);
  }
  setBottomBorder(options) {
    this.currentOptions.bottomBorder = merge(this.currentOptions.bottomBorder, options);
    this.setTitleBar(this.currentOptions);
  }
  _addDarkModeListener() {
    var _a, _b, _c;
    (_c = (_a = window.matchMedia) == null ? void 0 : (_b = _a.call(window, "(prefers-color-scheme: dark)")).addListener) == null ? void 0 : _c.call(_b, this._darkModeChangedEventListener);
  }
  _removeDarkModeListener() {
    var _a, _b, _c;
    (_c = (_a = window.matchMedia) == null ? void 0 : (_b = _a.call(window, "(prefers-color-scheme: dark)")).removeListener) == null ? void 0 : _c.call(_b, this._darkModeChangedEventListener);
  }
  _setZIndex(options) {
    this.elTitleBar.style.zIndex = options.zIndex ? options.zIndex.toString() : "";
  }
  _setTitleArea(options) {
    this.elTitleBar.style.height = options.height + "px";
    this.elTitle.style.lineHeight = options.height + 1 + "px";
    if (options.visible) {
      this.elTitleBar.style.display = "block";
      if (this.elRoot) {
        this.elRoot.style.top = `${options.height}px`;
        this.elRoot.style.height = `calc(100% - ${options.height})`;
      }
    } else {
      this.elTitleBar.style.display = "none";
      this.elTitleBar.style.height = "0";
      if (this.elRoot) {
        this.elRoot.style.top = "0";
        this.elRoot.style.height = "100%";
      }
    }
    this.elTitleBar.style.backgroundColor = this.isDarkMode() ? options.backgroundColor.dark : options.backgroundColor.light;
    this.elTitle.innerText = options.title.text;
    this.elTitle.style.cssFloat = options.title.align;
    if (options.title.bold) {
      this.elTitle.style.fontWeight = "bold";
    } else {
      this.elTitle.style.fontWeight = "normal";
    }
    this.elTitle.style.overflow = "hidden";
    this.elTitle.style.textOverflow = "ellipsis";
    this.elTitle.style.whiteSpace = "nowrap";
    this.elTitle.style.maxWidth = "100%";
    this.elTitle.style.fontSize = options.title.size + "px";
    this.elTitle.style.color = this.isDarkMode() ? options.title.color.dark : options.title.color.light;
    if (this._isEllipsisActive(this.elTitle)) {
      this.elTitle.style.padding = `0px ${options.right.visible ? "61px" : "30px"} 0px ${options.left.visible ? "61px" : "30px"}`;
    } else {
      this.elTitle.style.padding = `0px  61px 0px 61px`;
    }
  }
  _setLeftButton(options) {
    if (options.left.icon) {
      this.elLeftImage.innerHTML = options.left.icon(
        this.isDarkMode() ? options.left.color.dark : options.left.color.light
      );
    }
    if (options.left.visible) {
      this.elLeft.style.visibility = "visible";
    } else {
      this.elLeft.style.visibility = "hidden";
    }
    if (this.leftEventListener) {
      this.elLeft.removeEventListener("click", this.leftEventListener);
      this.leftEventListener = null;
    }
    this.leftEventListener = options.left.callback;
    this.elLeft.addEventListener("click", this.leftEventListener);
  }
  _setRightButton(options) {
    if (options.right.icon) {
      this.elRightImage.innerHTML = options.right.icon(
        this.isDarkMode() ? options.right.color.dark : options.right.color.light
      );
    }
    if (this.rightEventListener) {
      this.elRight.removeEventListener("click", this.rightEventListener);
      this.rightEventListener = null;
    }
    this.rightEventListener = options.right.callback;
    this.elRight.addEventListener("click", this.rightEventListener);
    if (options.right.visible) {
      this.elRight.style.visibility = "visible";
    } else {
      this.elRight.style.visibility = "hidden";
    }
  }
  _isEllipsisActive(element) {
    if (!element) {
      return false;
    }
    return element.offsetWidth < element.scrollWidth;
  }
  getNavigationButtonPadding() {
    return Device.isIos() ? "10px" : "16px";
  }
  getNavigationButtonMargin() {
    return Device.isIos() ? "4px" : "0px";
  }
  createTitleBar() {
    const elTitleBar = document.createElement("div");
    elTitleBar.id = "titleBar";
    elTitleBar.style.cssText = "position:fixed; top:0; left:0; width:100%; text-align:center; border:0 solid;";
    elTitleBar.setAttribute("data-size", "normal");
    elTitleBar.innerHTML = `<button id="left" style="position: absolute; left: 0; top: 0; padding:${this.getNavigationButtonPadding()}; margin-left:${this.getNavigationButtonMargin()};">
                                <svg id="leftImage" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"/>
                              </button>
                              <button id="title" style="font-size:23px; padding: 0 61px;">타이틀</button>
                              <button id="right" style="position: absolute; right: 0; top: 0; padding:${this.getNavigationButtonPadding()}; margin-right:${this.getNavigationButtonMargin()};">
                                <svg id="rightImage" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"/>
                              </button>
                            `;
    return elTitleBar;
  }
  isDarkMode() {
    if (this.currentOptions.disableDarkmode) {
      return false;
    }
    return document.body.classList.contains(DARK_MODE_CLASSNAME) || window.matchMedia("(prefers-color-scheme: dark)").matches;
  }
}
const navigationBarController = new NavigationBarController();
export {
  NavigationBarController,
  navigationBarController
};
